import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Shared";
import { SECTORS } from "@/data/sectors";

export default function Sectors() {
  return (
    <section
      id="sectors"
      data-testid="sectors-section"
      className="border-t border-[rgba(212,175,55,0.12)] bg-[#0A1222]/40 py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHead
          overline="Sectors We Serve"
          title={<>Arenas where policy meets <em className="gold-text not-italic">the market.</em></>}
          testId="sectors-heading"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {SECTORS.map((s, i) => (
            <Reveal key={s.id} delay={(i % 4) * 0.07} className="h-full">
              <a
                href={`/sectors/${s.id}`}
                data-testid={`sector-card-${s.id}`}
                className="group flex h-full flex-col border border-[rgba(212,175,55,0.15)] bg-[#0F1A2E]/70 transition-colors duration-500 hover:border-[#D4AF37]/55"
              >
                <div className="relative h-44 overflow-hidden sm:h-48">
                  <img
                    src={s.img}
                    alt={s.alt}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0F1A2E] via-[#070E1B]/20 to-transparent" />
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <h3 className="font-serif text-xl text-[#F7F5F0] transition-colors duration-300 group-hover:text-[#E5C158]">
                    {s.name}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#94A3B8]">{s.desc}</p>
                  <span className="mt-auto flex items-center gap-2 pt-5 font-mono-alt text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]/0 transition-colors duration-500 group-hover:text-[#D4AF37]">
                    Explore Sector <ArrowUpRight size={13} />
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
